const rankingItems = [
  { id: 1, rank: 1, title: '顶流男星深夜密会神秘女子', heat: '982万', trend: 'up', change: '+2' },
  { id: 2, rank: 2, title: '综艺录制现场突发意外事故', heat: '876万', trend: 'up', change: '+5' },
  { id: 3, rank: 3, title: '知名网红被曝偷税遭封禁', heat: '754万', trend: 'hot', change: '新' },
  { id: 4, rank: 4, title: '当红女星婚变分居内幕', heat: '689万', trend: 'up', change: '+1' },
  { id: 5, rank: 5, title: '古装大剧路透照流出引争议', heat: '602万', trend: 'up', change: '+3' },
  { id: 6, rank: 6, title: '音乐节阵容官宣票价暴涨', heat: '531万', trend: 'down', change: '-2' },
  { id: 7, rank: 7, title: '娱乐圈最新恋情CP整理', heat: '458万', trend: 'up', change: '+4' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            实时更新的51吃瓜网站热门话题排行榜，一起看看今天大家都在关注什么吃瓜内容
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 px-5 md:px-8 py-4 md:py-5 border-b border-background-200/50 last:border-b-0 hover:bg-background-100/50 transition-colors cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 md:w-10 text-center">
                {item.rank <= 3 ? (
                  <span className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg font-heading text-sm md:text-base ${
                    item.rank === 1 ? 'bg-primary-500 text-background-50' :
                    item.rank === 2 ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm md:text-base font-medium text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 truncate">{item.title}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-3">
                <span className="text-xs md:text-sm text-foreground-400 whitespace-nowrap">{item.heat}</span>
                <span className={`text-xs font-medium whitespace-nowrap ${
                  item.trend === 'hot' ? 'text-primary-500' :
                  item.trend === 'up' ? 'text-accent-500' :
                  'text-foreground-400'
                }`}>
                  {item.change}
                </span>
                <i className={`text-sm ${
                  item.trend === 'hot' ? 'ri-fire-fill text-primary-500' :
                  item.trend === 'up' ? 'ri-arrow-up-fill text-accent-500' :
                  'ri-arrow-down-fill text-foreground-400'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}